<template>
    <div class="container py-3 py-lg-5 form-horizontal">
        <!--SEND TO SAP-->
        <div class="mb-5">
            <div class="row no-gutters">
                <div class="col-sm-8 offset-sm-2">
                    <!--  COMMON SHOPS -->
                    <div v-if="!isNGR" class="bg-white pt-5 pb-4 px-5">
                        <div class="row no-gutters">
                            <div class="col text-center">
                                <span v-text="_trans('Last updated')"></span>:
                                <strong v-if="$store.state.epoq.sequence > 0 && $store.state.epoq.qaData.simulationResult">
                                    {{ $store.state.epoq.qaData.simulationResult.timestamp | moment("D MMM YYYY") }}
                                </strong>
                                <strong v-else>-</strong>
                            </div>
                        </div>
                        <div class="row no-gutters">
                            <div class="col text-center">
                                <span v-text="_trans('Id')"></span>:
                                <strong v-if="$store.state.epoq.sequence > 0 && $store.state.epoq.qaData.simulationResult" v-text="$store.state.epoq.qaData.simulationResult.requestID"></strong>
                                <strong v-else>-</strong>
                            </div>
                        </div>
                        <div class="row no-gutters mt-4">
                            <div class="px-2" :class="isParentPrj ? 'col-12' : 'col-6'">
                                <button class="btn btn-info btn-block" @click="checkOrder()">
                                    <span v-text="_trans('Check Availability')"></span>
                                    <span class="badge rounded-circle bg-light text-info" style="padding: 4px 6px" v-text="sequence"></span>
                                </button>
                            </div>
                            <div v-if="!isParentPrj" class="col-6 px-2">
                                <!--<a class="btn btn-success ml5" ng-if="v.cansendorder()" ng-click="v.sendorder()"><span v-html="_trans('')">Send order to Elguide</span></a>-->
                                <!--<button class="btn btn-default" ng-if="v.cansendorder()" ng-click="v.sendorder()">-->
                                <!--<button class="btn btn-default" style="width: 100%" ng-disabled="v.cansendorder()" ng-click="v.sendorder()">-->
                                <!--<button class="btn btn-default" style="width: 100%" ng-click="v.sendorder()" ng-disabled="v.error > 0 && (v.prj.status != 'OFFER' || !v.selected.skipqa) && v.prj.status != 'APPROVED' && v.prj.status != 'ORDERED'">-->
                                <button class="btn btn-primary btn-block" :disabled="error > 0 || ((prj.status != 'OFFER' || !skipQa) && prj.status != 'APPROVED' && prj.status != 'ORDERED')" @click="sendOrder()" v-html="_trans('Send order to elguide')"></button>
                            </div>
                        </div>
                        <div class="row no-gutters mt-1">
                            <div class="col px-2">
                                <button type="button" class="btn btn-xs" :class="{ 'btn-outline-info': !modeJson, 'btn-primary': modeJson }" @click="swapJson()" v-html="_trans('swap json')"></button>
                                <!--<a class="btn bg-transparent text-info px-0" @click="swapJson()" v-html="_trans('swap json')"></a>-->
                            </div>
                            <div v-show="seller > 1" class="col px-2">
                                <div class="d-flex justify-content-end">
                                    <label v-if="!isParentPrj">
                                        <input v-model="skipQa" type="checkbox" :disabled="sequence === 2 || prj.status === 'AWAITING APPROVAL'" :true-value="1" :false-value="0" />
                                        <span v-text="_trans('Skip QA')"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- NGR SHOPS -->
                    <div v-else class="bg-white pt-5 pb-4 px-5">
                        <div class="row no-gutters">
                            <div class="col text-center">
                                <span v-text="_trans('Last updated')"></span>:
                                <strong v-if="$store.state.epoq.sequence > 0 && $store.state.epoq.qaDataNGR.timestamp">
                                    {{ $store.state.epoq.qaDataNGR.timestamp | moment("D MMM YYYY") }}
                                </strong>
                                <strong v-else>-</strong>
                            </div>
                        </div>
                        <!-- <div class="row no-gutters">
                <div class="col text-center">
                    <span v-html="_trans('Id')"></span>:
                    <strong
                        v-if="$store.state.epoq.sequence > 0 && $store.state.epoq.qaData.simulationResult"
                        v-text="$store.state.epoq.qaData.simulationResult.requestID"
                    ></strong>
                    <strong v-else>-</strong>
                </div>
            </div>-->
                        <div class="row no-gutters mt-4">
                            <!-- <div class="px-2" :class="isParentPrj ? 'col-12' : 'col-6'"> -->
                            <div class="px-2 col-12">
                                <button class="btn btn-info btn-block" @click="checkOrderNGR()">
                                    <span v-text="_trans('Check Availability')"></span>
                                    <span class="badge rounded-circle bg-light text-info" style="padding: 4px 6px" v-text="sequence"></span>
                                </button>
                            </div>
                            <!-- <div v-if="!isParentPrj" class="col-6 px-2" @click="sendOrderNGR">
                                <button class="btn btn-primary btn-block" :disabled="((qaDataNGR.items || qaDataNGR.worktopItems) && (qaDataNGR.items.length || qaDataNGR.worktopItems.length)) && (prj.status === 'APPROVED' || prj.status === 'ORDERED')" @click="sendOrderNGR()" v-text="_trans('Send to Blueberry')"></button>
                                <button class="btn btn-primary btn-block" :disabled="!((qaDataNGR.items || qaDataNGR.worktopItems) && (qaDataNGR.items.length || qaDataNGR.worktopItems.length))" @click="sendOrderNGR()" v-text="_trans('Send to Blueberry')"></button>
                            </div> -->
                        </div>
                        <div class="row no-gutters mt-1">
                            <div class="col px-2">
                                <button type="button" class="btn btn-xs d-none" :class="{ 'btn-outline-info': !modeJson, 'btn-primary': modeJson }" @click="swapJson()" v-text="_trans('swap json')"></button>
                            </div>
                            <!-- <div
                                v-show="seller > 1"
                                class="col px-2"
                            >
                                <div class="d-flex justify-content-end">
                                    <label v-if="!isParentPrj">
                                        <input
                                            v-model="skipQa"
                                            type="checkbox"
                                            :disabled="(sequence === 2) || prj.status === 'AWAITING APPROVAL'"
                                            :true-value="1"
                                            :false-value="0"
                                        />
                                        <span v-text="_trans('Skip QA')"></span>
                                    </label>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--RECEIVED DATA-->
        <div v-if="modeJson">
            <div class="row no-gutters">
                <div class="col-6 p-3">
                    <h3 class="text-center">3Cad Json</h3>
                    <pre class="border" v-text="returnedPrj"></pre>
                    <!--<pre>{{ v.prj | json}}</pre>-->
                </div>
                <div class="col-6 p-3">
                    <h3 class="text-center">Epoq Json from GetOrderChangeSimulate</h3>
                    <pre class="border" v-text="qaData"></pre>
                </div>
                <!--<div class="col p-3">
          <h3>Epoq Json from GetOrderCreate</h3>
          <pre>{{ v.sent | json}}</pre>
        </div>-->
            </div>
        </div>
        <div v-else>
            <div v-if="modeSend" class="row no-gutters">
                <div class="col-6 offset-3">
                    <!--<d-group title="Order Sent to Elguide">-->
                    <div title="Order Sent to Elguide">
                        <!--<pre>{{v.sent | json}}</pre>-->
                        <a class="btn btn-default pull-right" v-html="_trans('Back')"></a>
                    </div>
                </div>
            </div>
            <div v-else-if="!modeSend && sequence > 0 && qaData.messages && qaData.messages.length">
                <table class="table table-borderless table-responsive table-sm text-center">
                    <thead>
                        <tr>
                            <th width="2%" v-text="_trans('row')"></th>
                            <th width="13%" v-text="_trans('Message ID')"></th>
                            <th width="70%" v-text="_trans('Message')"></th>
                            <th width="15%" v-text="_trans('Type')"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(x, j) in qaData.messages" :key="j" :class="{ 'bg-danger text-white': x.type.toLowerCase() === 'error' }">
                            <td>{{ x.row }}</td>
                            <td>{{ x.id }}</td>
                            <td>{{ x.message }}</td>
                            <td>{{ x.type }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <!--PRODUCTION ARTICLES-->
                <h4 v-if="qaData.simulationResult && qaData.simulationResult.productionLines.length > 0" class="text-center" v-text="_trans('Production Articles')"></h4>
                <div v-if="qaData.simulationResult && qaData.simulationResult.productionLines.length > 0">
                    <div class="row no-gutters">
                        <div class="col-6 offset-3">
                            <table class="table table-bordered table-sm text-center">
                                <tbody>
                                    <tr>
                                        <th width="50%" v-text="_trans('Availability')"></th>
                                        <th>{{ qaData.simulationResult.productionLinesAvailability }}</th>
                                    </tr>
                                    <tr>
                                        <td width="50%" v-text="_trans('First available delivery date customer')"></td>
                                        <td>
                                            <span v-if="qaData.simulationResult.productionLinesFirstDeliveryDateToCustomer">
                                                {{ [qaData.simulationResult.productionLinesFirstDeliveryDateToCustomer.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <table class="table table-striped table-bordered table-sm text-center">
                        <thead class="thead-light">
                            <tr>
                                <th v-text="_trans('Article')"></th>
                                <th v-text="_trans('Description')"></th>
                                <th v-text="_trans('Quantity')"></th>
                                <th v-text="_trans('Availability')"></th>
                                <th v-text="_trans('Delivery date hub')"></th>
                                <th v-text="_trans('Elguide Order')"></th>
                                <th v-text="_trans('Include')"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(x, k) in qaData.simulationResult.productionLines" :key="k">
                                <td>{{ x.productID }}</td>
                                <td>{{ x.description }}</td>
                                <td>{{ x.requestedQuantity }}</td>
                                <td v-text="_trans(x.availability)"></td>
                                <td>
                                    <span v-if="x.firstAvailabilityDate">{{ [x.firstAvailabilityDate.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}</span>
                                </td>
                                <td>{{ x.salesOrderNumberElguide }}</td>
                                <td>
                                    <input v-if="!x.salesOrderNumberElguide" v-model="x.includeInOrder" type="checkbox" :true-value="true" :false-value="false" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!--STANDARD ARTICLES-->
                <h4 v-if="qaData.simulationResult && qaData.simulationResult.standardLines.length > 0" class="text-center" v-text="_trans('Standard Articles')"></h4>
                <div v-if="qaData.simulationResult && qaData.simulationResult.standardLines.length > 0">
                    <div class="row no-gutters">
                        <div class="col-6 offset-3">
                            <table class="table table-bordered table-sm text-center">
                                <tbody>
                                    <tr>
                                        <th width="50%" v-text="_trans('Availability')"></th>
                                        <th>{{ qaData.simulationResult.standardLinesAvailability }}</th>
                                    </tr>
                                    <tr>
                                        <td width="50%" v-text="_trans('First available delivery date customer')"></td>
                                        <td>
                                            <span v-if="qaData.simulationResult.standardLinesFirstDeliveryDateToCustomer">
                                                {{ [qaData.simulationResult.standardLinesFirstDeliveryDateToCustomer.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <table class="table table-striped table-bordered table-sm text-center">
                        <thead class="thead-light">
                            <tr>
                                <th v-text="_trans('Article')"></th>
                                <th v-text="_trans('Description')"></th>
                                <th v-text="_trans('Quantity')"></th>
                                <th v-text="_trans('Availability')"></th>
                                <th v-text="_trans('Delivery date hub')"></th>
                                <th v-text="_trans('Elguide Order')"></th>
                                <th v-text="_trans('Include')"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(x, k) in qaData.simulationResult.standardLines" :key="k">
                                <td>{{ x.productID }}</td>
                                <td>{{ x.description }}</td>
                                <td>{{ x.requestedQuantity }}</td>
                                <td v-text="_trans(x.availability)"></td>
                                <td>
                                    <span v-if="x.firstAvailabilityDate">{{ [x.firstAvailabilityDate.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}</span>
                                </td>
                                <td>{{ x.salesOrderNumberElguide }}</td>
                                <td>
                                    <input v-if="!x.salesOrderNumberElguide" v-model="x.includeInOrder" type="checkbox" :true-value="true" :false-value="false" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!--CUSTOM INSTALLATION-->
                <h4 v-if="qaData.simulationResult && qaData.simulationResult.customInstallationLines.length > 0" class="text-center" v-text="_trans('Custom Installation')"></h4>
                <div v-if="qaData.simulationResult && qaData.simulationResult.customInstallationLines.length > 0">
                    <div class="row no-gutters">
                        <div class="col-6 offset-3">
                            <table class="table table-bordered table-sm text-center">
                                <tbody>
                                    <tr>
                                        <th width="50%" v-text="_trans('Availability')"></th>
                                        <th>{{ qaData.simulationResult.customInstallationLinesAvailability }}</th>
                                    </tr>
                                    <tr>
                                        <td width="50%" v-text="_trans('First available delivery date customer')"></td>
                                        <td>
                                            <span v-if="qaData.simulationResult.customInstalltionLinesFirstDeliveryDateToCustomer">
                                                {{ [qaData.simulationResult.customInstalltionLinesFirstDeliveryDateToCustomer.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <table class="table table-striped table-bordered table-sm text-center">
                        <thead class="thead-light">
                            <tr>
                                <th v-text="_trans('Article')"></th>
                                <th v-text="_trans('Description')"></th>
                                <th v-text="_trans('Quantity')"></th>
                                <th v-text="_trans('Availability')"></th>
                                <th v-text="_trans('Delivery date hub')"></th>
                                <th v-text="_trans('Elguide Order')"></th>
                                <th v-text="_trans('Include')"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(x, h) in qaData.simulationResult.customInstallationLines" :key="h">
                                <td>{{ x.productID }}</td>
                                <td>{{ x.description }}</td>
                                <td>{{ x.requestedQuantity }}</td>
                                <td v-text="_trans(x.availability)"></td>
                                <td>
                                    <span v-if="x.firstAvailabilityDate">{{ [x.firstAvailabilityDate.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}</span>
                                </td>
                                <td>{{ x.salesOrderNumberElguide }}</td>
                                <td>
                                    <input v-if="!x.salesOrderNumberElguide" v-model="x.includeInOrder" type="checkbox" :true-value="true" :false-value="false" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- EXISTING ORDERS -->
            <div v-if="qaData.existingOrders && qaData.existingOrders.length > 0" class="row no-gutters">
                <div>
                    <h4 class="text-center" v-text="_trans('Existing Orders')"></h4>
                    <div v-for="(x, t) in qaData.existingOrders" :key="t">
                        <!--ng-if="sequence==2"-->
                        <div class="row no-gutters">
                            <div class="col-6 offset-3">
                                <table class="table table-striped table-bordered table-sm text-center">
                                    <thead class="thead-light">
                                        <tr>
                                            <th width="20%" v-text="_trans('SAP Order')"></th>
                                            <th width="20%" v-text="_trans('Status')"></th>
                                            <th width="20%" v-text="_trans('Prod. start')"></th>
                                            <th width="20%" v-text="_trans('Delivery date hub')"></th>
                                            <!--<th width="20%" v-html="_trans('')">Employee</th>-->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ x.salesOrderNumberSAP }}</td>
                                            <td>{{ x.status }}</td>
                                            <td>{{ [x.productionStartDate.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}</td>
                                            <td>{{ [x.hubDeliveryDate.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!--<pre v-text="x"></pre>-->
                            <div v-if="x.orderLinesToKeep && x.orderLinesToKeep.length > 0">
                                <h6 v-text="_trans('Order Lines to Keep:')"></h6>
                                <div>
                                    <table class="table table-striped table-compressed">
                                        <thead class="thead-light">
                                            <tr>
                                                <!--<th>SAP row no-gutters</th>-->
                                                <!--<th>ElGuide row no-gutters</th>-->
                                                <th v-text="_trans('Article')"></th>
                                                <th v-text="_trans('Description')"></th>
                                                <th v-text="_trans('Req Qty')"></th>
                                                <th v-text="_trans('Confirm Qty')"></th>
                                                <th v-text="_trans('Availability')"></th>
                                                <th v-text="_trans('Prod Start Date')"></th>
                                                <th v-text="_trans('Goods Issue Date')"></th>
                                                <th v-text="_trans('Confirm Delivery Date')"></th>
                                                <th v-text="_trans('Request Delivery Date')"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(y, j) in x.orderLinesToKeep" :key="j">
                                                <!--<td class="number">{{y.salesOrderLineNumberSAP}}</td>-->
                                                <!--<td class="number">{{y.salesOrderLineNumberElguide}}</td>-->
                                                <td>{{ y.productID }}</td>
                                                <td>{{ y.description }}</td>
                                                <td class="text-center">
                                                    {{ y.requestedQuantity }}
                                                </td>
                                                <td class="text-center">
                                                    {{ y.confirmedQuantity }}
                                                </td>
                                                <td class="text-center">
                                                    {{ y.status }}
                                                </td>
                                                <td class="center">
                                                    {{ [y.productionStartDate.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}
                                                </td>
                                                <td class="center">
                                                    {{ [y.goodsIssueDate.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}
                                                </td>
                                                <td class="center">
                                                    {{ [y.confirmedHubDeliveryDate.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}
                                                </td>
                                                <td class="center">
                                                    {{ [y.requestedHubDeliveryDate.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-if="x.orderLinesToRemove && x.orderLinesToRemove.length > 0">
                                <h6 v-html="_trans('Order Lines to Remove:')"></h6>
                                <div>
                                    <table class="table table-striped table-compressed">
                                        <thead class="thead-light">
                                            <tr>
                                                <!--<th>SAP row no-gutters</th>-->
                                                <!--<th>ElGuide row no-gutters</th>-->
                                                <th v-text="_trans('Article')"></th>
                                                <th v-text="_trans('Description')"></th>
                                                <th v-text="_trans('Req Qty')"></th>
                                                <th v-text="_trans('Confirm Qty')"></th>
                                                <th v-text="_trans('Availability')"></th>
                                                <th v-text="_trans('Prod Start Date')"></th>
                                                <th v-text="_trans('Goods Issue Date')"></th>
                                                <th v-text="_trans('Confirm Delivery Date')"></th>
                                                <th v-text="_trans('Request Delivery Date')"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="y in x.orderLinesToRemove" :key="y.productID" class="text-danger">
                                                <!--<td class="number" style="color: #e05633;">{{y.salesOrderLineNumberSAP}}</td>-->
                                                <!--<td class="number" style="color: #e05633;">{{y.salesOrderLineNumberElguide}}</td>-->
                                                <td>{{ y.productID }}</td>
                                                <td>{{ y.description }}</td>
                                                <td>{{ y.requestedQuantity }}</td>
                                                <td>{{ y.confirmedQuantity }}</td>
                                                <td>{{ y.status }}</td>
                                                <td>{{ [y.productionStartDate.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}</td>
                                                <td>{{ [y.goodsIssueDate.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}</td>
                                                <td>{{ [y.confirmedHubDeliveryDate.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}</td>
                                                <td>{{ [y.requestedHubDeliveryDate.toString(), "YYYYMMDD"] | moment("D MMM YYYY") }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- NGR -->
        <div v-if="qaDataNGR">
            <h4 v-if="qaDataNGR.items && qaDataNGR.items.length" class="text-center" v-text="_trans('Standard Articles')"></h4>
            <b-table
                v-if="qaDataNGR.items && qaDataNGR.items.length"
                :items="qaDataNGR.items"
                :busy="checkingAvailabilityNGR"
                :fields="[
                    { key: 'mainArticle', label: 'Main Article', sortable: true, sortDirection: 'desc' },
                    { key: 'subArticle', label: 'Sub Article', sortable: true, sortDirection: 'desc' },
                    { key: 'des', label: 'Description', sortable: true, sortDirection: 'desc' },
                    { key: 'deliveryDate', label: 'Earliest', sortable: true, class: 'text-center' },
                    { key: 'qt', label: 'Quantity', sortable: true, class: 'text-center' }
                ]"
                stacked="md"
                show-empty
                small
            >
                <template #head(include)>
                    <b-form-checkbox v-model="includeAllNGR" :indeterminate="qaDataNGR.items.filter(x => x.subArticle && x.include).length !== 0 && qaDataNGR.items.filter(x => x.subArticle && x.include).length !== qaDataNGR.items.filter(x => x.subArticle).length" :true-value="true" :false-value="false" @change="toggleSelectNGR"></b-form-checkbox>
                </template>
                <template #cell(mainArticle)="row">
                    <strong v-if="!row.item.subArticle">{{ row.item.mainArticle }}</strong>
                    <span v-else style="color: #bbb">{{ row.item.mainArticle }}</span>
                </template>
                <template #cell(deliveryDate)="row">
                    {{ row.item.deliveryDate | moment("D MMM YYYY") }}
                </template>

                <template #cell(include)="row">
                    <!-- PARENT -->
                    <b-form-checkbox v-if="!row.item.subArticle" v-model="row.item.include" :true-value="true" :false-value="false" :indeterminate="qaDataNGR.items.filter(x => x.mainArticle === row.item.mainArticle && x.subArticle && x.include).length !== 0 && qaDataNGR.items.filter(x => x.mainArticle === row.item.mainArticle && x.subArticle).length !== qaDataNGR.items.filter(x => x.mainArticle === row.item.mainArticle && x.subArticle && x.include).length" @change="toggleParentNGR($event, row.item)"></b-form-checkbox>
                    <!-- CHILD -->
                    <b-form-checkbox v-else v-model="row.item.include" :true-value="true" :false-value="false"></b-form-checkbox>
                </template>

                <template #row-details="row">
                    <b-card>
                        <ul>
                            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                        </ul>
                    </b-card>
                </template>
            </b-table>
            <hr v-if="qaDataNGR.worktopItems && qaDataNGR.worktopItems.length" />
            <h4 v-if="qaDataNGR.worktopItems && qaDataNGR.worktopItems.length" class="text-center" v-text="_trans('Worktop Articles')"></h4>
            <b-table
                v-if="qaDataNGR.worktopItems && qaDataNGR.worktopItems.length"
                :items="qaDataNGR.worktopItems"
                :busy="checkingAvailabilityNGR"
                :fields="[
                    { key: 'mainArticle', label: 'Main Article', sortable: true, sortDirection: 'desc' },
                    { key: 'subArticle', label: 'Sub Article', sortable: true, sortDirection: 'desc' },
                    { key: 'des', label: 'Description', sortable: true, sortDirection: 'desc' },
                    { key: 'deliveryDate', label: 'Earliest', sortable: true, class: 'text-center' },
                    { key: 'qt', label: 'Quantity', sortable: true, class: 'text-center' }
                ]"
                stacked="md"
                show-empty
                small
            >
                <template #head(include)>
                    <b-form-checkbox v-model="includeAllWNGR" :indeterminate="qaDataNGR.worktopItems.filter(x => x.subArticle && x.include).length !== 0 && qaDataNGR.worktopItems.filter(x => x.subArticle && x.include).length !== qaDataNGR.worktopItems.filter(x => x.subArticle).length" :true-value="true" :false-value="false" @change="toggleSelectWNGR"></b-form-checkbox>
                </template>
                <template #cell(mainArticle)="row">
                    <strong v-if="!row.item.subArticle">{{ row.item.mainArticle }}</strong>
                    <span v-else style="color: #bbb">{{ row.item.mainArticle }}</span>
                </template>
                <template #cell(deliveryDate)="row">
                    {{ row.item.deliveryDate | moment("D MMM YYYY") }}
                </template>

                <template #cell(include)="row">
                    <!-- PARENT -->
                    <b-form-checkbox v-if="!row.item.subArticle" v-model="row.item.include" :true-value="true" :false-value="false" :indeterminate="qaDataNGR.worktopItems.filter(x => x.mainArticle === row.item.mainArticle && x.subArticle && x.include).length !== 0 && qaDataNGR.worktopItems.filter(x => x.mainArticle === row.item.mainArticle && x.subArticle).length !== qaDataNGR.worktopItems.filter(x => x.mainArticle === row.item.mainArticle && x.subArticle && x.include).length" @change="toggleParentNGR($event, row.item)"></b-form-checkbox>
                    <!-- CHILD -->
                    <b-form-checkbox v-else v-model="row.item.include" :true-value="true" :false-value="false"></b-form-checkbox>
                </template>

                <template #row-details="row">
                    <b-card>
                        <ul>
                            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                        </ul>
                    </b-card>
                </template>
            </b-table>
            <!-- <pre>{{ qaDataNGR }}</pre> -->
        </div>
    </div>
</template>
<script>
    import { NextApiClient } from "@3cad/nextcore";
    import { bus } from "@store/dau";
    import { EDBasketData } from "@custom/_modules/EDBasketData";

    export default {
        data() {
            return {
                chainsData: require("@assets/epoq/json/chainsData.json"),
                modeSend: false,
                modeJson: false,
                includeAllNGR: false,
                includeAllWNGR: false,
                indeterminateAllNGR: false,
                error: 0,
                checkingAvailabilityNGR: false,
                returnedPrj: {},
                qa: {}
            };
        },
        computed: {
            preferences() {
                return this.$store.getters["getPreferences"];
            },

            chain() {
                if (!this.preferences.config.chainid) {
                    return null;
                } else return this.preferences.config.chainid;
            },
            countryCode() {
                return this.chainsData.filter(r => {
                    return r.id === this.chain;
                })[0].countryCode;
            },
            prj() {
                return this.$store.state.project;
            },
            seller() {
                return this.user.seller;
            },
            sequence() {
                return this.$store.state.epoq.sequence;
            },
            skipQa: {
                set: function (val) {
                    this.$store.state.epoq.skipQa = val;
                },
                get: function () {
                    return this.$store.state.epoq.skipQa;
                }
            },
            qaData() {
                return this.$store.state.epoq.qaData;
            },
            qaDataNGR() {
                return this.$store.state.epoq.qaDataNGR;
            },
            /*canSendOrder() {
       if (this.sequence < 1)
       return false;
       else
       return (this.selected.skipqa > 0 && this.prj.status==="OFFER") || this.prj.status==="ORDER" || this.prj.status==="APPROVED" || this.prj.status==="ORDERED";
       }*/
            isParentPrj() {
                return this.$store.getters["epoq/isParentPrj"];
            },
            operatingChain() {
                let chainId = this.preferences.config.chainid;
                return this.chainsData.find(r => {
                    return r.id === chainId;
                });
            }
        },
        watch: {
            "qaDataNGR.items": {
                handler: function (val) {
                    // Check if all items are checked
                    let all = val.filter(x => x.subArticle).length;
                    let checked = val.filter(x => x.subArticle && x.include).length;
                    this.includeAllNGR = checked === all;

                    // Check parent items are checked or not
                    const parentItems = val.filter(x => !x.subArticle);
                    parentItems.forEach(p => {
                        const subItems = val.filter(x => x.mainArticle === p.mainArticle && x.rowId === p.rowId && x.subArticle);
                        const included = subItems.filter(s => s.include);
                        p.include = included.length !== 0;
                    });
                },
                deep: true
            },
            "qaDataNGR.worktopItems": {
                handler: function (val) {
                    // Check if all items are checked
                    let all = val.filter(x => x.subArticle).length;
                    let checked = val.filter(x => x.subArticle && x.include).length;
                    this.includeAllWNGR = checked === all;

                    // Check parent items are checked or not
                    const parentItems = val.filter(x => !x.subArticle);
                    parentItems.forEach(p => {
                        const subItems = val.filter(x => x.mainArticle === p.mainArticle && x.rowId === p.rowId && x.subArticle);
                        const included = subItems.filter(s => s.include);
                        p.include = included.length !== 0;
                    });
                },
                deep: true
            }
        },
        created() {
            let prj = this.prj;
            if (this.user.seller >= 2)
                this.skipQa = 1;
            /*switch (prj.status.toLowerCase()) {
            case 'unassigned':
            case 'assigned':
            case 'seller design':
                prj.priceDate = ( new Date() ).toInt();
                break;
        }*/

            // Necessary to fill for epoq
            prj.priceDate = new Date().toInt();
            prj.delivery.countrycode = prj.shippingaddress[0].countrycode || prj.orderaddress[0].countrycode;
            prj.delivery.postalcode = prj.shippingaddress[0].postalcode || prj.orderaddress[0].postalcode;
            prj.delivery.chain = this.chain;

            if ((!this.isParentPrj && !prj.delivery.countrycode) || !prj.delivery.chain) throw "Delivery fields as countrycode, postalcode or chain can't be undefined";

            bus.$emit("startLoading");
            this.recompute()
                .then(json => {
                    bus.$emit("stopLoading");
                })
                .catch(err => {
                    console.error(err);
                    bus.$emit("stopLoading");
                });
        },
        mounted() {},
        methods: {
            /** Return promise
             * @returns {Promise<any>}
             */
            recompute() {
                return this.$store.dispatch("project/recompute", {});
            },
            checkForError(obj) {
                let aMsg = obj.messages || [];

                for (let i = 0; i < aMsg.length; i++) {
                    if (aMsg[i].type.toLowerCase().indexOf("error") > -1) {
                        this.error++;
                        break;
                    }
                }
            },
            swapJson() {
                if (!this.modeJson) {
                    bus.$emit("startLoading");
                    NextApiClient.combase(
                        this.preferences.config.mediation,
                        "ElWeb",
                        "ParseDataOrder",
                        {
                            _UID: NextApiClient.getUID(),
                            nextbe: NextApiClient.backSite,
                            data: JSON.stringify(this.prj.getJson()),
                            endpoint: this.preferences.config.extServices.orderSrv
                        },
                        json => {
                            this.returnedPrj = json;
                            this.modeJson = true;
                            bus.$emit("stopLoading");
                        },
                        err => {
                            console.error(err);
                            bus.$emit("stopLoading");
                        }
                    );
                } else {
                    this.modeJson = false;
                }
            },
            checkOrder() {
                this.error = 0;
                this.$store.commit("epoq/increment");
                //                if (this.sequence > 1)
                //                    this.sequence = 1;

                switch (this.$store.state.epoq.sequence) {
                    case 0:
                        // clear all
                        this.$store.commit("epoq/setQa", {});
                        break;
                    case 1:
                    default:
                        // to do refresh
                        if (this.preferences.config.extServices && this.preferences.config.extServices.orderSrv) {
                            bus.$emit("startLoading", this._trans("Checking availability in Elguide"));
                            /*Dau.combase(
                       Dau.g.config.mediation,
                       "ElWeb",
                       'GetOrderChangeSimulate2',*/
                            NextApiClient.combase(
                                this.preferences.config.mediation,
                                "ElWeb",
                                "GetOrderChangeSimulate2",
                                {
                                    _UID: NextApiClient.getUID(),
                                    nextbe: NextApiClient.backSite,
                                    data: JSON.stringify(this.prj.getJson()),
                                    endpoint: this.preferences.config.extServices.orderSrv
                                },
                                json => {
                                    this.$store.commit("epoq/setQa", json);
                                    this.checkForError(json);
                                    bus.$emit("stopLoading");
                                },
                                err => {
                                    console.error(err);
                                    bus.$emit("stopLoading");
                                }
                            );
                        }
                        break;
                }
            },
            homeDeliveryIndications(params) {
                return new Promise((resolve, reject) => {
                    NextApiClient.com(
                        "zcElkjop",
                        "HomeDeliveryIndications",
                        {
                            _UID: NextApiClient.getUID(),
                            requestBody: params
                        },
                        resolve,
                        reject
                    );
                });
            },
            async checkOrderNGR() {
                this.error = 0;
                this.checkingAvailabilityNGR = true;
                this.$store.commit("epoq/increment");
                //                if (this.sequence > 1)
                //                    this.sequence = 1;

                switch (this.$store.state.epoq.sequence) {
                    case 0:
                        // clear all
                        this.$store.commit("epoq/setQa", {});
                        break;
                    case 1:
                    default:
                        // to do refresh
                        console.log("call webservice", this.operatingChain);
                        console.log(this.prj.rows[0].erp);
                        // Create an array of all prj.rows.erp.bom.codes
                        // { prj.rows: [ { erp: [ { bom: { cod: '' } } ] } ] }
                        let mainItems = [];
                        let worktopItems = [];
                        // this.prj.rows.forEach( r => r.erp.forEach( e => e.bom.forEach( b => {
                        this.prj.rows.forEach(r => {
                            let isWorktop = false;
                            const tmpItems = [];
                            const wtmpItems = [];
                            r.erp.forEach(e => {
                                // if (/01WGENERIC/gi.test(e.cod)) debugger;
                                isWorktop = /^[5]/gi.test(String(e.mat)) || /^60[0-2]{1}[0-9]{3}$/gi.test(String(e.mat));
                                /*if (!isWorktop) {
                                    isWorktop = /^[5]/gi.test(String(e.mat));
                                    // if (isWorktop) debugger;
                                }*/

                                if (e.cod) {
                                    /*tmpItems.push({
                                        mainArticle: e.cod,
                                        des: e.desTrad,
                                        qt: e.qt,
                                        rowId: r.uniqueid,
                                        include: true
                                    });*/
                                    if(isWorktop)
                                        wtmpItems.push({
                                            mainArticle: e.cod,
                                            des: e.desTrad,
                                            qt: e.qt,
                                            rowId: r.uniqueid,
                                            include: true
                                        });
                                    else
                                        tmpItems.push({
                                            mainArticle: e.cod,
                                            des: e.desTrad,
                                            qt: e.qt,
                                            rowId: r.uniqueid,
                                            include: true
                                        });
                                }
                                e.bop.forEach(b => {
                                    /*if(b.cod.charAt(0) !== 'E') {
                                return;
                            }*/
                                    // if (!isWorktop)
                                    //         isWorktop = b.flmis === "M__";

                                    const isInnerWorktop = /^613[0-9]{2}$/.test(b.rep)
                                    const qt = b.flmis === "M__" ? b.qty * 100 : b.qty;

                                    // const found = deliveryItems.find(d => d.ArticleNumber === b.cod);
                                    /*if (found) {
                                        found.Quantity += e.qt * Math.ceil(qt);
                                    } else {*/
                                    /*deliveryItems.push({
                                        //rowId: r.uniqueid,
                                        //mainArticle: e.cod,
                                        des: b.desTrad,
                                        ArticleNumber: b.cod,
                                        Quantity: e.qt * Math.ceil(qt)
                                    });*/

                                    if (e.cod) {
                                        if(isInnerWorktop) wtmpItems.push({
                                            rowId: r.uniqueid,
                                            mainArticle: e.cod,
                                            subArticle: b.cod,
                                            des: b.desTrad,
                                            qt: e.qt * Math.ceil(qt),
                                            include: true
                                        });
                                        else
                                            tmpItems.push({
                                                rowId: r.uniqueid,
                                                mainArticle: e.cod,
                                                subArticle: b.cod,
                                                des: b.desTrad,
                                                qt: e.qt * Math.ceil(qt),
                                                include: true
                                            });
                                    }
                                    //}
                                });
                            });

                            /*if (isWorktop) worktopItems = [...worktopItems, ...tmpItems];
                            else mainItems = [...mainItems, ...tmpItems];*/
                            worktopItems = [...worktopItems, ...wtmpItems];
                            mainItems = [...mainItems, ...tmpItems];
                        });

                        try {
                            const res = await this.homeDeliveryIndications(
                                JSON.stringify({
                                    CountryCode: this.operatingChain.countryCode,
                                    MainOperatingChain: this.operatingChain.op,
                                    PostalCode: this.prj.shippingaddress[0].postalcode,
                                    DeliveryItems: [
                                        ...mainItems
                                            .filter(x => x.subArticle)
                                            .map(x => {
                                                return {
                                                    ArticleNumber: x.subArticle,
                                                    Quantity: x.qt
                                                };
                                            }),
                                        ...worktopItems
                                            .filter(x => x.subArticle)
                                            .map(x => {
                                                return {
                                                    ArticleNumber: x.subArticle,
                                                    Quantity: x.qt
                                                };
                                            })
                                    ]
                                    // DeliveryItems: deliveryItems
                                })
                            );
                            res.deliveryItems.forEach(d => {
                                /*const find = mainItems.find(m => m.subArticle === d.articleNumber && m.qt === d.quantity);
                                if (find) {
                                    find.deliveryDate = d.deliveryDate;
                                }
                                else {
                                    const findw = worktopItems.find(m => m.subArticle === d.articleNumber && m.qt === d.quantity);
                                    if (findw) {
                                        findw.deliveryDate = d.deliveryDate;
                                    }
                                    else {
                                        console.error("Not found", d);
                                    }
                                }*/
                                const find = mainItems.filter(m => m.subArticle === d.articleNumber);
                                if (find.length) {
                                    find.forEach(f => {
                                        f.deliveryDate = d.deliveryDate;
                                    });
                                } else {
                                    const findw = worktopItems.filter(m => m.subArticle === d.articleNumber && m.qt);
                                    if (findw.length) {
                                        findw.forEach(f => {
                                            f.deliveryDate = d.deliveryDate;
                                        });
                                    } else {
                                        console.error("Not found", d);
                                    }
                                }
                            });

                            this.$store.commit("epoq/setQaNGR", {
                                // ...res,
                                items: mainItems,
                                worktopItems: worktopItems,
                                timestamp: new Date()
                            });
                        } catch (err) {
                            console.error(err);
                        } finally {
                            this.checkingAvailabilityNGR = false;
                        }
                        break;
                }
            },
            sendOrder() {
                bus.$emit("startLoading", this._trans("Transfering order to Elguide"));

                NextApiClient.combase(
                    this.preferences.config.mediation,
                    "ElWeb",
                    "GetOrderCreate2",
                    {
                        _UID: NextApiClient.getUID(),
                        nextbe: NextApiClient.backSite,
                        data: JSON.stringify(this.qaData),
                        endpoint: this.preferences.config.extServices.orderSrv
                    },
                    json => {
                        this.$store.commit("epoq/setQa", json);

                        if (!json.messages || !json.messages.length) {
                            this.$store
                                .dispatch("project/setStatus", { prjId: this.prj.id, status: "ORDERED" })
                                .then(() => {
                                    bus.$emit("updateNotifications");
                                    bus.$emit("stopLoading");
                                })
                                .catch(() => {
                                    bus.$emit("stopLoading");
                                });
                        } else bus.$emit("stopLoading");
                    },
                    err => {
                        console.error(err);
                        bus.$emit("stopLoading");
                    }
                );
            },
            async getCustomerIdentity(email) {
                let obj = {
                    Email: email,
                    Country: this.countryCode
                };
                return new Promise((resolve, reject) => {
                    NextApiClient.combase(
                        this.preferences.config.mediation,
                        "elweb",
                        "SearchIdentity",
                        {
                            UGUEST: null,
                            identityID: null,
                            _UID: NextApiClient.getUID(),
                            nextbe: NextApiClient.backSite,
                            data: JSON.stringify(obj),
                            endpoint: this.preferences.config.extServices.customerSrv
                        },
                        res => {
                            resolve(res);
                        },
                        err => {
                            reject(err);
                        }
                    );
                });
            },
            async blueberryOrder(EDData) {
                return new Promise((resolve, reject) => {
                    NextApiClient.combase(
                        this.preferences.config.mediation,
                        "elweb",
                        "NGRKitchenDesigner",
                        {
                            _UID: NextApiClient.getUID(),
                            nextbe: NextApiClient.backSite,
                            data: JSON.stringify(EDData),
                            endpoint: this.preferences.config.extServices.ngrSrv
                        },
                        resolve,
                        reject
                    );
                });
            },
            async sendOrderNGR() {
                try {
                    console.log(this.prj.orderaddress);
                    // Check master identity
                    /*let {Identities} = await this.getCustomerIdentity(this.prj.orderaddress[0].email)
                    if (!Identities.length || Identities[0].IdentityId !== this.customer.extra) {
                        this.$3cadInfo({
                            title: this._trans("Identity check failed"),
                            body: `${this._trans("The customer registered on the project is not the customer’s primary identity, please change customer before proceeding.")}`
                        });
                        return
                    }*/

                    // TODO: Check parent or common project

                    bus.$emit("startLoading", "Revaluate prices", 0.083);
                    console.log("%cTop calculation and revaluate prices...", "color: blue");

                    await this.$store.dispatch("project/recompute", {});
                    bus.$emit("startLoading", "Saving project", 0.17);
                    console.log("%cSaving project...", "color: blue");

                    // Set version number to prj
                    // TODO: Understand version number
                    // this.$set(this.prj, 'versionNumber', 1);

                    // bus.$emit('startLoading', 'Generating version', 0.33);
                    // console.log('%cGenerating version...', 'color: blue');
                    // await this.$store.dispatch('project/createVersion', {name: this.prj.des})

                    bus.$emit("startLoading", "Sending data", 0.9);
                    const EDData = await EDBasketData.convertPrj(this.prj, this.skipQa);
                    const FEDData = EDBasketData.filteredData(EDData, this.qaDataNGR.items, this.qaDataNGR.worktopItems);
                    const res = await this.blueberryOrder(FEDData);

                    /* bus.$emit("startLoading", this._trans("Transfer order"));
                try {
                    this.$store
                        .dispatch("project/setStatus", {
                            prjId: this.prj.id,
                            status: "AWAITING APPROVAL",
                            extraData: { prjver: this._trans("For approval") + ": " + this.prj.currentVersion }
                        })
                        .finally(() => {
                            bus.$emit("updateNotifications");
                            bus.$emit("stopLoading");
                        });
                } catch (err) {
                    console.error(err);
                }*/
                } catch (err) {
                    console.error(err);
                } finally {
                    bus.$emit("stopLoading");
                }
            },
            toggleSelectNGR(value) {
                this.qaDataNGR.items.forEach(x => (x.include = value));
            },
            toggleSelectWNGR(value) {
                this.qaDataNGR.worktopItems.forEach(x => (x.include = value));
            },
            toggleParentNGR(value, item) {
                const subItems = this.qaDataNGR.items.filter(x => x.mainArticle === item.mainArticle && x.subArticle);
                const subWItems = this.qaDataNGR.worktopItems.filter(x => x.rowId === item.rowId && x.mainArticle === item.mainArticle && x.subArticle);
                subItems.forEach(s => {
                    s.include = value;
                });
                subWItems.forEach(s => {
                    s.include = value;
                });
            }
            /*,
        orderLinestoKeep(id) {
            if(this.qaData && this.qaData.orderLinesToKeep) {
                return this.qaData.orderLinesToKeep.filter( x => {
                    return x.salesOrderNumberSAP === id;
                });
            } else
                return [];
        },
        orderLinestoRemove(id) {
            if(this.qaData && this.qaData.orderLinesToRemove) {
                return this.qaData.orderLinesToRemove.filter( x => {
                    return x.salesOrderNumberSAP === id;
                });
            } else
                return [];
        }*/
        }
    };
</script>


// WEBPACK FOOTER //
// src/custom/epoq/pages/order.vue